import { SaveUserEmailRequest } from './../../interfaces/SaveUserEmail'
import { atom } from 'jotai'
import { fbGetUserMetadata } from '../../data/FirebaseEnrich'

import { auth } from '../../data/FirebaseInit'
import { SaveUserEmail } from '../../data/SaveUserEmail'
import { UpdateProfile } from '../../data/UpdateProfile'
import { ProfileMetadata } from '../../interfaces'
import { readFile } from '../../utils/file'

export const isEditProfileOpenAtom = atom<boolean>(false)

export const rwDIDAtom = atom<string | null>(null)
export const rwDIDSignatureRequestAtom = atom<string | null>(null)
export const profileMetadataAtom = atom<ProfileMetadata | null>(null)

export const rwProfileMetadataAtom = atom(
  (get) => get(profileMetadataAtom),
  (_, set, metadata: ProfileMetadata) => {
    set(profileMetadataAtom, metadata)
  }
)

export const wUpdateProfileAtom = atom(null, (_get, set, metadata: MetadataUpdate) => {
  const updateProfile = async (): Promise<void> => {
    const address = auth?.currentUser?.uid

    if (address) {
      const updateWithExtraData = async (extra = {}): Promise<void> => {
        await UpdateProfile(address, {
          display_name: metadata.name,
          bio: metadata.bio,
          instagram_link: metadata.instagram,
          youtube_link: metadata.youtube,
          twitter_link: metadata.twitter,
          ...extra,
        })
        const newProfileMetadata = await fbGetUserMetadata(address)

        set(rwProfileMetadataAtom, newProfileMetadata as ProfileMetadata)
        set(isEditProfileOpenAtom, false)
      }

      if (metadata.profilePic && metadata.banner) {
        // both images
        const profilePicURI = await readFile(metadata.profilePic)
        const bannerURI = await readFile(metadata.banner)
        await updateWithExtraData({
          banner_image_uri: bannerURI,
          profile_image_uri: profilePicURI,
        })
      } else if (metadata.profilePic) {
        // just profile pic
        const profilePicURI = await readFile(metadata.profilePic)
        await updateWithExtraData({
          profile_image_uri: profilePicURI,
        })
      } else if (metadata.banner) {
        // just banner
        const bannerURI = await readFile(metadata.banner)
        await updateWithExtraData({
          banner_image_uri: bannerURI,
        })
      } else {
        // not updating images
        await updateWithExtraData()
      }
    }
  }

  updateProfile()
})

export interface MetadataUpdate {
  name?: string
  bio?: string
  profilePic?: File
  banner?: File
  youtube?: string
  instagram?: string
  twitter?: string
}

// Atom to save the email address for notifications

export const wSaveNotificationsEmailAtom = atom(null, (_, __, email: string) => {
  const saveUserEmail = async (): Promise<void> => {
    const address = auth?.currentUser?.uid

    const request: SaveUserEmailRequest = {
      email,
    }

    if (address) {
      await SaveUserEmail(address, request)
    } else {
      // TODO: when user is not signed in, show a message
    }
  }

  saveUserEmail()
})
